import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/authService';

function AuthRoute({ children }: React.PropsWithChildren): any {
  return !authService.isLoggedIn() ? children : <Navigate to="/" />;
}

export default AuthRoute;
